import script from "./ComponentsProvider.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComponentsProvider.vue?vue&type=script&setup=true&lang=ts"

import "./ComponentsProvider.vue?vue&type=style&index=0&id=3205ac6f&scoped=true&lang=scss"

import exportComponent from "/var/www/fgc-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3205ac6f"]])

export default __exports__